import { connectRouter } from 'connected-react-router';
import { History, MemoryHistory } from 'history';
import { combineReducers, Reducer } from 'redux';
import { reducer as kanbanReducer } from 'b2b-apps/core/kanban';
import { reducer as assortmentReducer } from 'b2b-apps/shop/assortment/redux/reducer';
import { reducer as breadcrumbsReducer } from 'b2b-apps/shop/breadcrumbs/redux/reducer';
import { reducer as cartReducer } from 'b2b-apps/shop/cart/redux/reducer';
import { reducer as catalogReducer } from 'b2b-apps/shop/catalog/redux/reducer';
import { reducer as checkoutReducer } from 'b2b-apps/shop/checkout/redux/reducer';
import { reducer as collectedOrderReducer } from 'b2b-apps/shop/collectedOrder/redux/reducer';
import { reducer as contentReducer } from 'b2b-apps/shop/content/redux/reducer';
import { reducer as contextReducer } from 'b2b-apps/shop/context/redux/reducer';
import { reducer as expressOrderReducer } from 'b2b-apps/shop/expressOrder/redux/reducer';
import { reducer as i18nReducer } from 'b2b-apps/shop/i18n/redux/reducer';
import { reducer as manufacturerReducer } from 'b2b-apps/shop/manufacturer/redux/reducer';
import { reducer as myAccountReducer } from 'b2b-apps/shop/myAccount/common/redux/reducer';
import { reducer as newsletterReducer } from 'b2b-apps/shop/newsletter/redux/reducer';
import { reducer as productReducer } from 'b2b-apps/shop/product/redux/reducer';
import { reducer as punchoutReducer } from 'b2b-apps/shop/punchout/testPages/redux/reducer';
import { reducer as settingsReducer } from 'b2b-apps/shop/settings/redux/reducer';
import { Action, State } from './types';

const reducers = {
  assortment: assortmentReducer,
  breadcrumbs: breadcrumbsReducer,
  cart: cartReducer,
  catalog: catalogReducer,
  checkout: checkoutReducer,
  collectedOrder: collectedOrderReducer,
  content: contentReducer,
  context: contextReducer,
  expressOrder: expressOrderReducer,
  i18n: i18nReducer,
  kanban: kanbanReducer,
  manufacturer: manufacturerReducer,
  myAccount: myAccountReducer,
  newsletter: newsletterReducer,
  product: productReducer,
  punchout: punchoutReducer,
  settings: settingsReducer,
};

const combine = (
  history: History | MemoryHistory,
): Reducer<State, Action> => combineReducers<any, any>({
  ...reducers,
  router: connectRouter(history),
});

type Reducers = typeof reducers;

type CombinedReducers = Reducers & {
  router: typeof connectRouter;
};

export type {
  CombinedReducers,
  Reducer,
};
export { reducers };
export default combine;
